module.exports = __webpack_public_path__ + "static/media/转接模块A2.8be7706b.png";